import { useState } from 'react';

export default function FloatingButtons() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-gray-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap">
          Scrivici su WhatsApp!
        </div>
      )}

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/393806328251?text=Ciao%2C%20vorrei%20informazioni%20sulle%20stufe%20a%20pellet"
        target="_blank"
        rel="nofollow noreferrer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5a] text-white rounded-full transition-all hover:scale-110 cursor-pointer"
        aria-label="Contattaci su WhatsApp"
      >
        <i className="ri-whatsapp-fill text-2xl"></i>
      </a>

      {/* Call Button */}
      <a
        href="tel:+393806328251"
        className="w-12 h-12 flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white rounded-full transition-all hover:scale-110 cursor-pointer"
        aria-label="Chiama ora"
      >
        <i className="ri-phone-fill text-xl"></i>
      </a>
    </div>
  );
}
